import React, {ReactNode, useState, useEffect} from 'react';
import LanguageHandler from "./LanguageHandler";

export const LanguageProvider = ({children}: { children: ReactNode }) => {
    const [key, setKey] = useState(0); // Add a key to force re-render

    useEffect(() => {
        // Pass a function that will update the key when language changes
        LanguageHandler._setForceUpdate(() => setKey(prev => prev + 1));

        // Cleanup - pass an empty function instead of null
        return () => {
            LanguageHandler._setForceUpdate(() => {
            });
        };
    }, []);

    // Use the key to force re-render of children
    return <React.Fragment key={key}>{children}</React.Fragment>;
};